import { CrudViewFormItemType, CrudFormConfig, CrudFormTextBoxItem, InputSize } from '@rappider/rappider-components/utils';
import { Validators } from '@angular/forms';

export const EDIT_SLOT_DEFINITION_CONFIG: CrudFormConfig = {
  items: [
    {
      title: 'ID',
      fieldName: 'id',
      type: CrudViewFormItemType.Label,
    },
    <CrudFormTextBoxItem>{
      title: 'Title',
      fieldName: 'title',
      type: CrudViewFormItemType.TextBox,
      size: InputSize.Large,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.TITLE_REQUIRED'
        }
      ]
    },
    <CrudFormTextBoxItem>{
      title: 'Key',
      fieldName: 'key',
      type: CrudViewFormItemType.TextBox,
      size: InputSize.Large,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.TITLE_REQUIRED'
        }
      ]
    },
    {
      title: 'SHARED.INDEX',
      fieldName: 'index',
      type: CrudViewFormItemType.Number,
      size: InputSize.Large
    },
    <CrudFormTextBoxItem>{
      title: 'Description',
      fieldName: 'description',
      type: CrudViewFormItemType.TextBox,
      size: InputSize.Large
    }
  ],
  submitButton: {
    visible: false
  }
};
